import { CrewLiveEventPusher } from "../CrewLiveEventPusher";
import { v4 as uuidv4 } from "uuid";
import { Client } from "urql";
import {
  PlaylistLivePositionEventName,
  PlaylistLivePositionPayload,
} from "./PlaylistLivePositionPayload";
import { LiveEventUbInputType } from "../../gql/graphql";

export function pushPlaylistLivePosition(
  graphQlClient: Client,
  currentCrewIdentifier: string,
  payload: PlaylistLivePositionPayload,
): void {
  const eventToPush = buildPlaylistLivePositionEvent(
    currentCrewIdentifier,
    payload,
  );
  CrewLiveEventPusher.offerCrewLiveEvent(eventToPush, graphQlClient)
    .then((r) => {
      console.debug("pushPlaylistLivePosition pushed event", {
        payload: payload,
        eventWithPayload: eventToPush,
        result: r,
      });
    })
    .catch((e) => console.error("pushPlaylistLivePosition failed", e));
}

export function buildPlaylistLivePositionEvent(
  currentCrewIdentifier: string,
  payload: PlaylistLivePositionPayload,
): LiveEventUbInputType {
  return {
    eventName: PlaylistLivePositionEventName,
    eventID: uuidv4(),
    crewId: currentCrewIdentifier,
    deviceIdentifier: payload.deviceIdentifier,
    deviceReadableName: payload.deviceReadableName,
    payload: JSON.stringify(payload),
    timestamp: new Date(),
  };
}
